import * as React from 'react';
import { SVGProps } from 'react';

const SvgParents = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M5.022 12.728v2.08a4.541 4.541 0 0 0 4.533 4.537 4.54 4.54 0 0 0 4.537-4.537v-2.08"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M5.022 14.803V12.72a4.537 4.537 0 0 1 9.07 0v2.083M3.504 33.736v-7.38a7.05 7.05 0 0 1 12.039-4.988"
    />
    <path
      fill="currentColor"
      d="m34.99 18.382-1.532-1.537.304-.277a2.21 2.21 0 0 1 3.113 0l-1.537 1.536a.031.031 0 0 0-.01-.006.031.031 0 0 0-.023 0 .032.032 0 0 0-.01.006l-.304.278Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m29.186 19.918-.444-.448a1.614 1.614 0 0 0-2.275 0l-3.219 3.226a4.288 4.288 0 0 0 1.39 6.984 4.23 4.23 0 0 0 1.643.32 4.235 4.235 0 0 0 3.03-1.262l3.219-3.226a1.617 1.617 0 0 0 0-2.28l-.459-.445"
    />
    <circle
      cx={32.2}
      cy={19.4}
      r={3.25}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M23 22.75h10m-16.36-11.7v2.246a4.904 4.904 0 0 0 4.894 4.9 4.904 4.904 0 0 0 4.899-4.9v-2.245"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M16.64 13.198v-2.25a4.9 4.9 0 0 1 9.793 0v2.25M14 33.736v-7.97a7.614 7.614 0 0 1 9.1-7.472c1.478.294 2.335.64 3.4 1.706M29 30.95V29"
    />
    <path
      fill={props.fill}
      d="M2.5 30.894v4.32l23.218.021 4.302-4.306-27.52-.035Z"
    />
  </svg>
);

export default SvgParents;
